"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ref_1 = require("ajv/dist/vocabularies/core/ref");
const core = [
    "$schema",
    "id",
    "$defs",
    { keyword: "$comment" },
    "definitions",
    ref_1.default,
];
exports.default = core;
//# sourceMappingURL=core.js.map